// extracted by mini-css-extract-plugin
module.exports = {"phrase":"phrase--qh4Hq","numbered":"numbered--yucTd","name":"name--Ic7ym","text":"text--LT8EZ","dialoguename":"dialoguename--v6eQv","dialoguetext":"dialoguetext--Ubkqg","container":"container--QUK2l","withAudio":"withAudio--v4Ip8","audio":"audio--TWyub","play":"play--VaWsu"};
    if(module.hot) {
      // 1653630378086
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  